import http from "../tools/http";

export default {
  getAll({ organizationUUID, pagination }) {
    return http.get(`/organizations/${organizationUUID}/widgets`, { params: pagination });
  },
  getOne({ organizationUUID, widgetUUID }) {
    return http.get(`/organizations/${organizationUUID}/widgets/${widgetUUID}`);
  },
  create({ organizationUUID, widget }) {
    return http.post(`/organizations/${organizationUUID}/widgets`, widget);
  },
  update({ organizationUUID, widget }) {
    return http.patch(`/organizations/${organizationUUID}/widgets/${widget.uuid}`, widget);
  },
  getHosts({ organizationUUID, widgetUUID }) {
    return http.get(`/organizations/${organizationUUID}/widgets/${widgetUUID}/hosts`);
  },
  addHost({ organizationUUID, host }) {
    return http.post(`/organizations/${organizationUUID}/widgets/hosts`, host);
  },
  deleteHost({ organizationUUID, hostUUID }) {
    return http.delete(`/organizations/${organizationUUID}/widgets/hosts/${hostUUID}`);
  }
};
